import {
  HomeHeroDiv,
  HomeHero,
  HomeCarouselDiv,
  HomeHeroMainDiv
} from "../../styles/homeComp/home";


import { Button } from "../../styles/reusable";
import TrustedComponent from "./trustedComponents";
import { IoIosApps, IoMdPlay } from "react-icons/io";
import { FaVectorSquare } from "react-icons/fa";
import TestimonialComponent from "./testimonial";
import Services from "./services";

import Tools from "./tools";
import DownloadSection from "./IndexCtaSection";



const HomeHeroComponent = () => {

  return (
    <HomeHeroMainDiv>

      <HomeHero>

        <div className="homehero-container">
          <div className="hero-header">
            <div className="new_modal">Try the latest FABLE-5 AI model</div>
            <div>
              <h1 className="header"> Your New AI Partner </h1>
              <p className="text">
                Meet Your New AI Coding Partner
                Build,<br /> debug, and ship faster with Sixth.</p>
            </div>

            <div className="button-flex">
              <div className="button">
                <Button
                  bg="white"
                  border="none"
                  color="black"
                  hoverBg="  #171717fe"
                  hoverColor="var(--text-black)"
                >
                  <a href="vscode://Sixth.sixth-ai/"> Start coding </a>
                </Button>

              </div>
              <div className="button">
                <Button
                  bg=" #171717fe"
                  border="none"
                  
                  color="white"
                  hoverBg="  #171717fe"
                  hoverColor="var(--text-black)"
                >
                  <a href="/pricing"> view pricing </a>
                </Button>

              </div>

            </div>

          </div>

        </div>


      </HomeHero>

      <TrustedComponent />
      <HomeCarouselDiv>
        <div>
          <img  loading ="lazy" src={"https://raw.githubusercontent.com/precious112/Pstore_backend/refs/heads/master/media/media/sixth_ai_docs_edit_1-ezgif.com-optimize.gif"} alt="sixth"></img>

          <div className="play">
            <IoMdPlay size={34} />
          </div>
        </div>
      </HomeCarouselDiv>

      <HomeHeroDiv>
        <section>
          {heroFeatures.map((item, index) => (
            <div key={index + ""} className="hero" id={"item" + index}>
              <div className="hero_header">
                <div className="flex">
                  <div>{item.svg}</div>

                  <p className="small_text"> {item.icon_text} </p>
                </div>
                <h1 className="center"> {item.header}</h1>
                <p className="center">{item.description}</p>
              </div>
              <section className="video_hero">
                <video className="video" autoPlay muted loop={true}>
                  <source src={item.icon} type="video/mp4"></source>
                </video>
              </section>
            </div>
          ))}
        </section>
      </HomeHeroDiv>
      <TestimonialComponent />
      <Services />
      <Tools />
      <DownloadSection />
      <div className='empty' />



    </HomeHeroMainDiv>
  );
};

export default HomeHeroComponent;

const heroFeatures = [
  {
    svg: <IoIosApps size={30} />,
    header: " Launch smarter apps in no time.",
    icon: "/images/airagvid.mp4",
    icon_text: "AI Rag",
    description:
      "Empower your tools with adaptive AI workflows built to scale instantly.",
  },
  {
    svg: <FaVectorSquare size={24} />,
    header: "Built to scale, ready to impress.",
    icon: "/images/vector.mp4",
    icon_text: "Agentic AI",
    description:
      "Power next-gen applications with real-time adaptive intelligence.",
  },
];
